/**
 * subcatsInOneCat description
 * @param  {object} obj 
 * @return {array}     
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.subcatsInOneCat = subcatsInOneCat;

function subcatsInOneCat(obj) {

  var output = Object.keys(obj);
  output[0] = 'All';
  //console.dir(output)
  return output;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9rYXJlbi9Eb2N1bWVudHMvbXlfcHJvamVjdC9mb29kL3NyYy9qcy9kYXRhTW9kZWwvc3ViY2F0c0luT25lQ2F0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7OztBQUtPLFNBQVMsZUFBZSxDQUFDLEdBQUcsRUFBQzs7QUFFbEMsTUFBSSxNQUFNLEdBQUcsTUFBTSxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQTtBQUM3QixRQUFNLENBQUMsQ0FBQyxDQUFDLEdBQUcsS0FBSyxDQUFBOztBQUVqQixTQUFPLE1BQU0sQ0FBQTtDQUNkIiwiZmlsZSI6Ii9Vc2Vycy9rYXJlbi9Eb2N1bWVudHMvbXlfcHJvamVjdC9mb29kL3NyYy9qcy9kYXRhTW9kZWwvc3ViY2F0c0luT25lQ2F0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBzdWJjYXRzSW5PbmVDYXQgZGVzY3JpcHRpb25cbiAqIEBwYXJhbSAge29iamVjdH0gb2JqIFxuICogQHJldHVybiB7YXJyYXl9ICAgICBcbiAqL1xuZXhwb3J0IGZ1bmN0aW9uIHN1YmNhdHNJbk9uZUNhdChvYmope1xuXG4gIGxldCBvdXRwdXQgPSBPYmplY3Qua2V5cyhvYmopXG4gIG91dHB1dFswXSA9ICdBbGwnXG4gIC8vY29uc29sZS5kaXIob3V0cHV0KVxuICByZXR1cm4gb3V0cHV0XG59Il19